module.exports = __webpack_public_path__ + "static/media/mainbackground4.1028c98d.jpg";